import React from 'react';
import { openWhatsAppConsultation } from '../../utils/whatsapp';
import './CTASection.css';

const CTASection = ({
  title,
  subtitle,
  buttonText = "ابدأ الآن",
  backgroundStyle = "gradient" // "gradient", "dark", or "light"
}) => {
  const handleClick = () => {
    openWhatsAppConsultation();
  };

  return (
    <section className={`cta-section cta-${backgroundStyle}`}>
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">{title}</h2>
          {subtitle && <p className="cta-subtitle">{subtitle}</p>}
          <button className="btn btn-whatsapp btn-large cta-button" onClick={handleClick}>
            {buttonText}
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
